/** Claves alineadas con backend `congresoEdicionAcl.utils` */
export const CONGRESO_SECTION_OPTIONS = [
  { key: "general", label: "General" },
  { key: "carta", label: "Carta de bienvenida" },
  { key: "cronograma", label: "Cronograma" },
  { key: "comites", label: "Comités" },
  { key: "talleres", label: "Talleres" },
  { key: "programa", label: "Programa científico" },
  { key: "comunicacion", label: "Comunicación y pósters" },
  { key: "sede", label: "Sede" },
  { key: "inscripcion", label: "Inscripción" },
  { key: "patrocinadores", label: "Patrocinadores" },
  { key: "organizador", label: "Organizador" },
  { key: "privacidad", label: "Política de privacidad" },
];

export const ACCESS_READ = "read";
export const ACCESS_SECTIONS = "sections";
export const ACCESS_EDITION_ADMIN = "edition_admin";
